import { createSlice } from '@reduxjs/toolkit';

import {
  estelamForeignNationalityThunk,
  estelamSabtAhvalThunk,
} from 'Feature/Common/Common/Actions/Thunks/estelamSabtAhvalThunk';
import { getActiveModdatHayeBimehNameh } from 'Feature/Common/Common/Actions/Thunks/getActiveModdatHayeBimehNameh';
import { getAddressWithPostCodeThunk } from 'Feature/Common/Common/Actions/Thunks/getAddressWithPostCodeThunk';
import { getActiveKhataratEzafi } from 'Feature/Khodro/ShakhsSales/Thunks/getActiveKhataratEzafi';
import { getActiveShoghlHaByNoeBimehAndNoeTabaghehShoghli } from 'Feature/Khodro/ShakhsSales/Thunks/getActiveShoghlHaByNoeBimehAndNoeTabaghehShoghli';
import { getAllCountries } from 'Feature/Khodro/ShakhsSales/Thunks/getAllCountries';
import { getAllNesbatHa } from 'Feature/Khodro/ShakhsSales/Thunks/getAllNesbatHa';
import { getAllTarhHayeSodoorByNoeBimeh } from 'Feature/Khodro/ShakhsSales/Thunks/getAllTarhHayeSodoorByNoeBimeh';
import LabelValueType from 'Shared/Core/Common/Models/LabelValueType';
import { ClearAllToasts } from 'Shared/Toast';

import {
  EstelamHadesehEnferadiThunk,
  GetActivePoosheshHayeHadesehEnferadiThunk,
  GetAllAnvaeSherkatBimeh,
  addBimehNamehEnferadiToOrder,
  createShenasehPardakht,
  getActiveKhataratTabiei,
} from './action';
import { IEnferadiEstelamState } from './model';

const initialState: IEnferadiEstelamState = {
  wizard: {
    beginStep: 1,
    endStep: 7,
    currentStep: 1,
  },
  moddatHayeBimehNameh: {
    loading: false,
    data: [],
  },
  getCodeShenasehPardakhtEnferadiResult: {
    loading: false,
    data: null,
  },
  anvaeSherkatBimeh: {
    loading: false,
    data: [],
  },
  estelamAndSodoorData: {
    bimehNameh: null,
    pooshesh: null,
    bimehGozar: null,
    bimehShodeh: null,
    address: null,
    bimehNamehGhabl: null,
  },
  getCodeShenasehPardakhtEnferadiCommand: {},
  isMablaghKharidBimehNamehMoreThanHaghBimeh: false,
  editMood: false,
  olaviatFotIsValid: true,
  editEstefadehKonandehCodeMelli: null,
  estelam: {
    loading: false,
    result: null,
  },

  estelamSabtAhval: {
    loading: false,
  },

  addToOrderResponse: {
    loading: false,
  },
  codeposti: {
    loading: false,
  },
  poosheshHa: {
    loading: false,
    data: null,
  },
  tarhHayeSodoor: {
    loading: false,
    data: null,
  },
  estefadehKonandehHa: null,

  khataratEzafi: {
    loading: false,
    data: null,
  },
  khataratTabiei: {
    loading: false,
    data: null,
  },
  shoghlHa: {
    loading: false,
    data: null,
  },
  countries: {
    loading: false,
    data: [],
  },
  nesbatHa: {
    loading: false,
    data: [],
  },
  isSuccess: false,
  haghBimehPardakhti: 0,

  estelamForeignNationality: {
    loading: false,
    isSuccess: false,
  },
};

export const enferadiEstelamSlice = createSlice({
  name: 'Enferadi/Estelam',
  initialState: initialState,
  reducers: {
    setBimehNamehData: (state, action) => {
      state.estelamAndSodoorData.bimehNameh = action.payload;
    },
    setAddressData: (state, action) => {
      state.estelamAndSodoorData.address = action.payload;
    },
    setPoosheshData: (state, action) => {
      state.estelamAndSodoorData.pooshesh = action.payload;
    },
    setBimehGozarData: (state, action) => {
      state.estelamAndSodoorData.bimehGozar = action.payload;
    },
    setBimehNamehGhabl: (state, action) => {
      state.estelamAndSodoorData.bimehNamehGhabl = action.payload;
    },
    setBimehShodehData: (state, action) => {
      state.estelamAndSodoorData.bimehShodeh = action.payload;
    },
    clearStepsData: (state) => {
      state.estelamAndSodoorData = initialState.estelamAndSodoorData;
      state.wizard = initialState.wizard;
    },
    setEditMood: (state, action) => {
      state.editMood = action.payload;
    },
    setOlaviatFotIsValid: (state, action) => {
      state.olaviatFotIsValid = action.payload;
    },
    clearTarafHayeGharardadCommand: (state) => {
      state.getCodeShenasehPardakhtEnferadiCommand.tarafHayeGharardad = null;
    },
    setIsMablaghKharidBimehNamehMoreThanHaghBimeh: (state, action) => {
      state.isMablaghKharidBimehNamehMoreThanHaghBimeh = action.payload;
    },
    setEstefadehKonandehHaCommand: (state, action) => {
      state.getCodeShenasehPardakhtEnferadiCommand.estefadehKonandehHa = action.payload;
    },
    setEditEstefadehKonandehCodeMelli: (state, action) => {
      state.editEstefadehKonandehCodeMelli = action.payload;
    },
    clearEstefadehKonandehHaCommand: (state) => {
      state.getCodeShenasehPardakhtEnferadiCommand.estefadehKonandehHa = null;
    },
    clearEstelamResult: (state) => {
      state.estelam.result = null;
    },
    clearBimehShodehCommand: (state) => {
      state.getCodeShenasehPardakhtEnferadiCommand.bimehShodeh = null;
    },
    setTarafHayeGharardadCommand: (state, action) => {
      state.getCodeShenasehPardakhtEnferadiCommand.tarafHayeGharardad = action.payload as any;
    },
    clearEstefadehKonandehHa: (state) => {
      state.estefadehKonandehHa = null;
    },
    wizardNextStep: (state) => {
      let nextStep = 0;
      if (state.wizard.currentStep === 3 && state.estelamAndSodoorData.bimehGozar?.isBimehShodeh) {
        nextStep = state.wizard.currentStep + 2;
      } else {
        nextStep = state.wizard.currentStep + 1;
      }
      if (nextStep <= state.wizard.endStep) {
        state.wizard.currentStep = nextStep;
      }
    },
    wizardPreviousStep: (state) => {
      let previousStep = 0;
      if (state.wizard.currentStep === 5 && state.estelamAndSodoorData.bimehGozar?.isBimehShodeh) {
        previousStep = state.wizard.currentStep - 2;
      } else {
        previousStep = state.wizard.currentStep - 1;
      }

      if (previousStep >= state.wizard.beginStep) {
        state.wizard.currentStep = previousStep;
      }

      ClearAllToasts();
    },
    setHaghBimehPardakhtiCommand: (state, action) => {
      state.haghBimehPardakhti = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetActivePoosheshHayeHadesehEnferadiThunk.pending, (state) => {
        state.poosheshHa.loading = true;
      })
      .addCase(GetActivePoosheshHayeHadesehEnferadiThunk.fulfilled, (state, action) => {
        state.poosheshHa.loading = false;
        if (action.payload !== undefined) {
          state.poosheshHa.data = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
            ejbari: item.ejbari,
            maxValue: item.maxValue,
            minValue: item.minValue,
            isPoosheshFot: item.isPoosheshFot,
            darsadSarmayehBeFot: item.darsadSarmayehBeFot,
            showMotevasetDaramadMahianeh: item.showMotevasetDaramadMahianeh,
          }));
        }

        return state;
      })
      .addCase(GetActivePoosheshHayeHadesehEnferadiThunk.rejected, (state) => {
        state.poosheshHa.loading = false;
      });

    builder
      .addCase(getAllNesbatHa.pending, (state) => {
        state.nesbatHa.loading = true;
      })
      .addCase(getAllNesbatHa.fulfilled, (state, action) => {
        state.nesbatHa.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
          }));
          state.nesbatHa.data = list;
        }
        return state;
      })
      .addCase(getAllNesbatHa.rejected, (state) => {
        state.nesbatHa.loading = false;
      });

    builder
      .addCase(getAllCountries.pending, (state) => {
        state.countries.loading = true;
      })
      .addCase(getAllCountries.fulfilled, (state, action) => {
        state.countries.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
          }));
          state.countries.data = list;
        }
        return state;
      })
      .addCase(getAllCountries.rejected, (state) => {
        state.countries.loading = false;
      });

    builder
      .addCase(getAllTarhHayeSodoorByNoeBimeh.pending, (state) => {
        state.tarhHayeSodoor.loading = true;
      })
      .addCase(getAllTarhHayeSodoorByNoeBimeh.fulfilled, (state, action) => {
        state.tarhHayeSodoor.loading = false;
        if (action.payload !== undefined) {
          state.tarhHayeSodoor.data = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
          }));
        }
        return state;
      })
      .addCase(getAllTarhHayeSodoorByNoeBimeh.rejected, (state) => {
        state.tarhHayeSodoor.loading = false;
      });
    builder
      .addCase(getActiveModdatHayeBimehNameh.pending, (state) => {
        state.moddatHayeBimehNameh.loading = true;
      })
      .addCase(getActiveModdatHayeBimehNameh.fulfilled, (state, action) => {
        state.moddatHayeBimehNameh.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.id,
            label: item.title,
          }));
          state.moddatHayeBimehNameh.data = list;
        }
        return state;
      })
      .addCase(getActiveModdatHayeBimehNameh.rejected, (state) => {
        state.moddatHayeBimehNameh.loading = false;
      });

    builder
      .addCase(getActiveKhataratEzafi.pending, (state) => {
        state.khataratEzafi.loading = true;
      })
      .addCase(getActiveKhataratEzafi.fulfilled, (state, action) => {
        state.khataratEzafi.loading = false;

        if (action.payload !== undefined) {
          state.khataratEzafi.data = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
          }));
        }

        return state;
      })
      .addCase(getActiveKhataratEzafi.rejected, (state) => {
        state.khataratEzafi.loading = false;
      });
    builder
      .addCase(getActiveKhataratTabiei.pending, (state) => {
        state.khataratTabiei.loading = true;
      })
      .addCase(getActiveKhataratTabiei.fulfilled, (state, action) => {
        state.khataratTabiei.loading = false;

        if (action.payload !== undefined) {
          state.khataratTabiei.data = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
          }));
        }

        return state;
      })
      .addCase(getActiveKhataratTabiei.rejected, (state) => {
        state.khataratTabiei.loading = false;
      });

    builder
      .addCase(estelamForeignNationalityThunk.pending, (state) => {
        state.estelamForeignNationality.loading = true;
        state.estelamForeignNationality.isSuccess = false;
      })
      .addCase(estelamForeignNationalityThunk.fulfilled, (state, action) => {
        state.estelamForeignNationality.loading = false;
        if (action.payload !== undefined) {
          state.estelamForeignNationality.isSuccess = true;
        }
      })
      .addCase(estelamForeignNationalityThunk.rejected, (state) => {
        state.estelamForeignNationality.loading = false;
        state.estelamForeignNationality.isSuccess = false;
      });

    builder
      .addCase(getActiveShoghlHaByNoeBimehAndNoeTabaghehShoghli.pending, (state) => {
        state.shoghlHa.loading = true;
      })
      .addCase(getActiveShoghlHaByNoeBimehAndNoeTabaghehShoghli.fulfilled, (state, action) => {
        state.shoghlHa.loading = false;
        if (action.payload !== undefined) {
          state.shoghlHa.data = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
          }));
        }
        return state;
      })
      .addCase(getActiveShoghlHaByNoeBimehAndNoeTabaghehShoghli.rejected, (state) => {
        state.shoghlHa.loading = false;
      });

    builder
      .addCase(EstelamHadesehEnferadiThunk.pending, (state) => {
        state.estelam.loading = true;
      })
      .addCase(EstelamHadesehEnferadiThunk.fulfilled, (state, action) => {
        state.estelam.loading = false;
        state.isSuccess = false;
        if (action.payload !== undefined) {
          state.estelam.result = action.payload;
          state.isSuccess = true;
        }

        return state;
      })
      .addCase(EstelamHadesehEnferadiThunk.rejected, (state) => {
        state.estelam.loading = false;
      });

    builder
      .addCase(createShenasehPardakht.pending, (state) => {
        state.getCodeShenasehPardakhtEnferadiResult.loading = true;
      })
      .addCase(createShenasehPardakht.fulfilled, (state, action) => {
        state.getCodeShenasehPardakhtEnferadiResult.loading = false;
        state.isSuccess = false;
        if (action.payload !== undefined) {
          state.getCodeShenasehPardakhtEnferadiResult.data = action.payload;
          state.isSuccess = true;
        }

        return state;
      })
      .addCase(createShenasehPardakht.rejected, (state) => {
        state.estelam.loading = false;
      });

    builder
      .addCase(estelamSabtAhvalThunk.pending, (state) => {
        state.estelamSabtAhval.loading = true;
      })
      .addCase(estelamSabtAhvalThunk.fulfilled, (state) => {
        state.estelamSabtAhval.loading = false;
      })
      .addCase(estelamSabtAhvalThunk.rejected, (state) => {
        state.estelamSabtAhval.loading = false;
      });

    builder
      .addCase(addBimehNamehEnferadiToOrder.pending, (state) => {
        state.addToOrderResponse.loading = true;
      })
      .addCase(addBimehNamehEnferadiToOrder.fulfilled, (state) => {
        state.addToOrderResponse.loading = false;
      })
      .addCase(addBimehNamehEnferadiToOrder.rejected, (state) => {
        state.addToOrderResponse.loading = false;
      });
    builder
      .addCase(GetAllAnvaeSherkatBimeh.pending, (state) => {
        state.anvaeSherkatBimeh.loading = true;
      })
      .addCase(GetAllAnvaeSherkatBimeh.fulfilled, (state, action) => {
        state.anvaeSherkatBimeh.loading = false;
        if (action.payload !== undefined) {
          const list: any[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.bimehMarkaziTitle,
          }));
          state.anvaeSherkatBimeh.data = list;
        }
        return state;
      })
      .addCase(GetAllAnvaeSherkatBimeh.rejected, (state) => {
        state.anvaeSherkatBimeh.loading = false;
      });

    builder
      .addCase(getAddressWithPostCodeThunk.pending, (state) => {
        state.codeposti.loading = true;
      })
      .addCase(getAddressWithPostCodeThunk.fulfilled, (state) => {
        state.codeposti.loading = false;
      })
      .addCase(getAddressWithPostCodeThunk.rejected, (state) => {
        state.codeposti.loading = false;
      });
  },
});

export const {
  setBimehNamehData,
  setPoosheshData,
  setAddressData,
  setTarafHayeGharardadCommand,
  setBimehGozarData,
  clearStepsData,
  clearEstefadehKonandehHaCommand,
  clearEstefadehKonandehHa,
  clearEstelamResult,
  setEditMood,
  setOlaviatFotIsValid,
  setHaghBimehPardakhtiCommand,
  wizardNextStep,
  clearTarafHayeGharardadCommand,
  setEditEstefadehKonandehCodeMelli,
  setEstefadehKonandehHaCommand,
  wizardPreviousStep,
  clearBimehShodehCommand,
  setBimehNamehGhabl,
  setIsMablaghKharidBimehNamehMoreThanHaghBimeh,
  setBimehShodehData,
} = enferadiEstelamSlice.actions;

export default enferadiEstelamSlice.reducer;
